module.exports = __webpack_public_path__ + "static/media/hilbi-logo.cb97bcfe.svg";